<template>
  <div class="wrapper_dark" :class="[{[locale]: locale}]" @click="interactCheck">
    <div class="header">
      <button class="btn_back" @click="back">
        <img src="@/assets/img/left-arrow.svg" />
      </button>
      <h1 class="title">{{ $tc("enter_phone_number") }}</h1>
      <button class="btn_exit" @click="goHome">{{ $tc("cancle") }}</button>
    </div>
    <div class="num_view">
      <span>{{ phoneNumber }}</span>
      <span v-if="!phoneNumber" class="num_view_text">
        {{ $tc("number_pad") }}
      </span>
    </div>
    <div class="num_pad_wrap">
      <ul class="num_pad">
        <li v-touch:start="addNumber">1</li>
        <li v-touch:start="addNumber">2</li>
        <li v-touch:start="addNumber">3</li>
        <li v-touch:start="addNumber">4</li>
        <li v-touch:start="addNumber">5</li>
        <li v-touch:start="addNumber">6</li>
        <li v-touch:start="addNumber">7</li>
        <li v-touch:start="addNumber">8</li>
        <li v-touch:start="addNumber">9</li>
        <li class="noshow_gray" v-touch:start="addNumber">{{ $tc("clear_all") }}</li>
        <li v-touch:start="addNumber">0</li>
        <li class="delete_btn" @click="deleteNumber">
          <img src="~@/assets/img/delect.svg" />
        </li>
        <!-- <li v-if="isHidden010" v-touch:start="addNumber">010</li>
        <li v-else></li> -->
      </ul>
      <!-- <div class="num_btn_wrap">
        <button class="crear_btn" v-touch:start="addNumber">{{ $tc("clear") }}</button>
        <button class="next_btn" :class="{ active: isActive }" @click="validation">{{ $tc("next") }}</button>
      </div> -->
      <div class="num_btn_wrap">
        <button class="next_btn" :class="{ active: isActive }" @click="validation">{{ $tc("next") }}</button>
      </div>
    </div>
    <Popup v-show="showPopup" @popControl="popup" />
    <PhoneCheckPopup v-if="showPhoneCheckPopup" @phoneCheckControl="phoneCheckControl" />
    <AlertPopup v-if="isAlert" :msg="msg" @AlertEvent="alertAction" />
    <timeout-popup :isShow="isShowTimeOutPop" @moveToHome="moveToHome" @close="closeTimeoutPopup"/>
  </div>
</template>

<script>
import { timeout } from './mixins/timeout'
import timeoutPopup from '@/components/TimeOutPopup.vue'
import Popup from '@/components/Popup.vue'
import PhoneCheckPopup from '@/components/PhoneCheckPopup.vue'
import AlertPopup from '@/components/AlertPopup'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'PhoneView',
  mixins: [timeout],
  components: {
    timeoutPopup,
    Popup,
    PhoneCheckPopup,
    AlertPopup
  },
  data () {
    return {
      userPhoneNumber: '',
      isActive: false,
      showPopup: false,
      showPhoneCheckPopup: false,
      msg: '',
      isAlert: false
    }
  },
  computed: {
    ...mapState(['locale']),
    ...mapGetters({ waitingParams: 'getWaitingParams', restaurant: 'getRestaurantInfo' }),
    isHidden010 () {
      return process.env.VUE_APP_HIDDEN_010 && process.env.VUE_APP_HIDDEN_010.includes(this.restaurant.idx)
    },
    // 전기통신번호관리세칙상 휴대폰 중간 번호는 2000번대부터 시작
    isInvalidMiddleNumber () {
      if (this.userPhoneNumber.substr(0, 3) !== '010') { return false }
      return Number(this.userPhoneNumber.substr(3, 4)) < 2000
    },
    phoneNumber () {
      let result = this.userPhoneNumber
      if (this.userPhoneNumber.length >= 3) {
        result = this.userPhoneNumber.substr(0, 3) + '-'
        result += this.userPhoneNumber.substr(3, 4)
        if (this.userPhoneNumber.length > 7) {
          result += '-'
          result += this.userPhoneNumber.substr(7, this.userPhoneNumber.length)
        }
      }
      return result
    }
  },
  methods: {
    deleteNumber () {
      this.userPhoneNumber = this.userPhoneNumber.substr(0, this.userPhoneNumber.length - 1)
      this.isActive = false
    },
    async addNumber (data) {
      let num = data
      const li = data.target
      li.classList.add('active')
      setTimeout(function () {
        li.classList.remove('active')
      }, 100)

      if (typeof data === 'object') {
        num = li.innerText
        if (
          li.innerText === '지우기' ||
          li.innerText === 'Delete' ||
          li.innerText === '消す' ||
          li.innerText === '删除'
        ) {
          this.userPhoneNumber = this.userPhoneNumber.substr(
            0,
            this.userPhoneNumber.length - 1
          )
        } else if (
          li.innerText === '전체삭제' ||
          li.innerText === 'Delete all' ||
          li.innerText === '全て消す' ||
          li.innerText === '全部删除'
        ) {
          this.userPhoneNumber = ''
          this.isActive = false
        } else if (num && this.userPhoneNumber.length < 11) {
          this.userPhoneNumber = this.userPhoneNumber + num
        }
      }
      if (this.userPhoneNumber.length === 11) {
        this.isActive = true
      } else {
        this.isActive = false
      }
    },

    validation () {
      if (!this.isActive) { return }
      let firstNum = /^[0]/ // 핸드폰 번호는 0으로 시작
      let patternNum = /[0-9]/ // 숫자

      // 숫자만 입력 체크
      if (
        firstNum.test(this.userPhoneNumber) &&
        patternNum.test(this.userPhoneNumber)
      ) {
        if (this.isInvalidMiddleNumber) {
          this.showPhoneCheckPopup = true
          return
        }
        this.next()
      } else {
        this.isActive = false
        this.isAlert = true
        this.msg = this.$tc('phone_check')
      }
    },
    phoneCheckControl (type) {
      this.showPhoneCheckPopup = false
      if (type === 'confirm') {
        this.next()
      }
    },
    next () {
      const params = {
        phoneNumber: this.userPhoneNumber
      }
      // this.$store.commit('waitingParams', params)
      this.$store.commit('setWaitingParams', params)
      this.$router.push('/select-person')
    },
    goHome () {
      this.showPopup = true
    },
    popup (type) {
      if (type === 'cancle') {
        this.$router.push('/')
      } else {
        this.showPopup = false
      }
    },
    back () {
      const path = (this.locale !== 'ko' && this.restaurant.foreignRequestType && this.restaurant.foreignRequestType.length > 0) ? '/bifurcation' : '/notice'
      this.$router.push(path)
    },
    alertAction (type) {
      if (type === 'close') {
        this.isAlert = false
      }
    }
  },
  mounted () {
    console.debug('VUE_APP_SHOW_010---', process.env.VUE_APP_SHOW_010, this.isHidden010)
    if (this.waitingParams.phoneNumber === '') {
      this.userPhoneNumber = this.isHidden010 ? '' : '010'
    } else {
      this.userPhoneNumber = this.waitingParams.phoneNumber
      this.isActive = true
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/base.scss";
.num_view {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 18.75vh;
  width: 100%;
  // padding: 5vh 0.78125vw;
  color: #2E3137;
  text-align: center;
  font-size: 90px; // IE11 fallback
  font-size: unquote("min(11.25vw, 90px)");
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.875vh;
  background: #F8F9FA;
  .num_view_text {
    font-size: 60px; // IE11 fallback
    font-size: unquote("min(7.5vw, 60px)");
    line-height: 1.4;
    letter-spacing: 1px;
  }
}
.num_pad_wrap {
  .num_pad {
    display: flex;
    flex-wrap: wrap;
    background: $white;
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 33%;
      padding: 3.75vh 0;
      height: 15.1875vh;
      color: #2E3137;
      text-align: center;
      font-size: 70px; // IE11 fallback
      font-size: unquote("min(8.75vh, 70px)");
      font-weight: 700;
      line-height: 1;
      border-top: 1.5px solid #B7BEC8;
      &:nth-child(2),
      &:nth-child(5),
      &:nth-child(8),
      &:nth-child(11) {
        border-left: 1px solid #B7BEC8;
        border-right: 1px solid #B7BEC8;
      }
      &.noshow_gray {
        font-size: 50px; // IE11 fallback
        font-size: unquote("min(6.25vh, 50px)");
        line-height: 1.1;
      }
      &.delete_btn {
        padding: 0;
      }
    }
  }
}
.num_btn_wrap {
  .next_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 94px;
    background: #B7BEC8;
    color: rgba(255, 255, 255, 0.59);
    font-size: 36px; // IE11 fallback
    font-size: unquote("min(4.5vh, 36px)");
    font-weight: 700;
    line-height: 1.055;
    &.active {
      cursor: pointer;
      color: #ffffff;
      background-color: #D81B1B;
    }
  }
}
.en, .jp, .cn_simplified {
  .num_view {
    .num_view_text {
      font-size: 52px; // IE11 fallback
      font-size: unquote("min(6.5vw, 52px)");
    }
  }
}
</style>
